// UserInfoDict.js
// DbdbTap 2024-09-19 10:44:59
import { InputType, TableColumnType, UserClass } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    userNid : {
		id: 'userNid', required: true, toAdd: false, toEdit: true,
	},
    userId : {
		id: 'userId', label: '사용자ID',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '25자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 25)},
	},
    authClassId : {
		id: 'authClassId', label: '권한',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
        labelKey: 'className',
        default: UserClass.store.id.toString()
	},
    /* dscId : {
		id: 'dscId', label: 'dscId',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 12)},
	}, */
    dcCd : {
		id: 'dcCd', label: '소속DC',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
        labelKey: 'dcName',
	},
    storeId : {
		id: 'storeId', label: '소속점포',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
        labelKey: 'storeName',
        getOptionLabel: (option) => 
            option.storeId ? option.storeName + ' (코드 ' + option.storeId + ') '
            + (option.addr ? option.addr.substring(0, 20) + '...' : '')
            : '',
	},
    comId : {
		id: 'comId', label: '소속운송사',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
        labelKey: 'comName',
        getOptionLabel: (option) => option.comId ? option.comName + ' (코드 ' + option.comId + ')' : '',
	},
    userName : {
		id: 'userName', label: '이름',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 36)},
	},
    password : {
		id: 'password', label: '암호',
		type: InputType.password, required: true, toAdd: true, toEdit: false,
		help: '대문자,소문자,숫자,기호 중 3가지 이상 섞어 8자 이상(개인정보보호법).',
		check: (value) => {return IsValid.passwordStrict(value)},
	},
    newPassword : {
		id: 'newPassword', label: '신규 암호',
		type: InputType.password, required: false, toAdd: false, toEdit: true,
		help: '대문자,소문자,숫자,기호 중 3가지 이상 섞어 8자 이상(개인정보보호법).',
		check: (value) => {return !Boolean(value) || IsValid.passwordStrict(value)},
	},
    passwordConfirm: {
        id: 'passwordConfirm', label: '암호확인',
        type: InputType.password, required: false, toAdd: true, toEdit: true,
        help: '신규 암호와 동일하게 입력하세요.',
    },
    zipCd : {
		id: 'zipCd', label: '우편번호',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 7)},
	},
    addr : {
		id: 'addr', label: '주소',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 120)},
	},
    telno : {
		id: 'telno', label: '연락처',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.string(value, 0, 15)},
	},
    /* mobile : {
		id: 'mobile', label: 'mobile',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '64자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 64)},
	},*/
    email : {
        id: 'email', label: '메일주소',
        type: InputType.email, required: false, toAdd: true, toEdit: true,
        help: '형식에 맞도록 메일주소를 입력하세요.',
        check: (value) => {return IsValid.nullString(value) || IsValid.email(value)},
    },
    useYn : {
		id: 'useYn', label: '사용구분',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	},
    allDcYn : {
		id: 'allDcYn', label: 'DC상태전환 가능',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
        trueValue: 'Y', falseValue: 'N',
		check: (value) => {return IsValid.string(value, 0, 1)},
	},
    /* secuAgreeYn : {
		id: 'secuAgreeYn', label: 'secuAgreeYn',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	},
    secuAgreeDate : {
		id: 'secuAgreeDate', label: 'secuAgreeDate',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
	}, */
    handlerYn : {
		id: 'handlerYn', label: '정보취급자 구분',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	},
    loginCnt : { id: 'loginCnt', label: '로그인횟수', },
    regTypeCd : {
		id: 'regTypeCd', label: '등록구분',
	},
    regType: {id:'regType', label: '등록구분',},
    /* cvoUserId : {
		id: 'cvoUserId', label: 'cvoUserId',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 40)},
	},
    cvoToken : {
		id: 'cvoToken', label: 'cvoToken',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '256자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 256)},
	},
    viewLevel : {
		id: 'viewLevel', label: 'viewLevel',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
    initLat : {
		id: 'initLat', label: 'initLat',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
    initLon : {
		id: 'initLon', label: 'initLon',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
    gcmId : {
		id: 'gcmId', label: 'gcmId',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '200자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 200)},
	},
    jsonMapConf : {
		id: 'jsonMapConf', label: 'jsonMapConf',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '8000자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 8000)},
	},
    auth2ndTime : {
		id: 'auth2ndTime', label: 'auth2ndTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	},
    auth2ndTxt : {
		id: 'auth2ndTxt', label: 'auth2ndTxt',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	},
    loginTime : {
		id: 'loginTime', label: 'loginTime',
	},
    lastActTime : {
		id: 'lastActTime', label: 'lastActTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	},
    logoutTime : {
		id: 'logoutTime', label: 'logoutTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, */
    className : {
		id: 'className', label: '권한',
	},
    // classRank : { id: 'classRank', label: 'classRank', },
    dcName : {
		id: 'dcName', label: '소속DC',
	},
    storeName : {
		id: 'storeName', label: '소속점포',
	},
    comName : {
		id: 'comName', label: '소속운송사',
	},
    
};

/**
 * USER_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-09-19 10:44:59 using DbdbTap
 */
export const UserInfoDictionary = {
    inputMap: {
        userNid: Dict.userNid,
        userId: Dict.userId,
        userName: Dict.userName,
        authClassId: Dict.authClassId,
        dcCd: Dict.dcCd,
        storeId: Dict.storeId,
        comId: Dict.comId,
        password: Dict.password,
        newPassword: Dict.newPassword,
        passwordConfirm: Dict.passwordConfirm,
        zipCd: Dict.zipCd,
        addr: Dict.addr,
        telno: Dict.telno,
        email: Dict.email,
        allDcYn: Dict.allDcYn,
    },
    viewMap: Dict,
    errorTitle: {
        Add: '사용자 등록 오류',
        Edit: '사용자 정보 수정 오류',
        Remove: '사용자 삭제 오류',
        Get: '사용자 정보 조회 오류',
        Upload: '사용자 정보 업로드 오류',
        SetHandler: '정보취급자 설정 오류',
        SetUsage: '사용자 사용여부 설정 오류',
        ChangePassword: '사용자 암호 변경 오류',
        ChangeMyPassword: '내 암호 변경 오류',
        ChangePassworOffline: '사용자 암호 변경(오프라인) 오류',
        CheckUserId: '사용자ID 중복 확인 오류',
    },
    tableProps: {
        tableId: 'userInfoTable',
        uniqueKey: 'userNid',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'userId', label: Dict.userId.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'userName', label: Dict.userName.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'className', label: Dict.className.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'dscId', label: Dict.dscId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: Dict.dcName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeName', label: Dict.storeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: Dict.comName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'comId', label: Dict.comId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'zipCd', label: Dict.zipCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'addr', label: Dict.addr.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'telno', label: Dict.telno.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'mobile', label: Dict.mobile.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'email', label: Dict.email.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'allDcYn', label: Dict.allDcYn.label, width: 100, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'전체':'소속DC구분'} },
            { id: 'useYn', label: Dict.useYn.label, width: 90, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'사용':'사용중지'} },
            //{ id: 'secuAgreeYn', label: Dict.secuAgreeYn.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'secuAgreeDate', label: Dict.secuAgreeDate.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regType', label: Dict.regType.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'handlerYn', label: Dict.handlerYn.label, width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'취급':'불허'} },
            { id: 'loginCnt', label: Dict.loginCnt.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'regDate', label: "등록일", width: 80, show: true, option:{align: 'center', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'loginTime', label: '마지막로그인', width: 120, show: true, option:{align: 'center', print:(r,i,v)=>ValueMisc.substr(v,0,16)} },
            /* { id: 'cvoUserId', label: Dict.cvoUserId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'cvoToken', label: Dict.cvoToken.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'viewLevel', label: Dict.viewLevel.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'initLat', label: Dict.initLat.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'initLon', label: Dict.initLon.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'gcmId', label: Dict.gcmId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'jsonMapConf', label: Dict.jsonMapConf.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'auth2ndTime', label: Dict.auth2ndTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'auth2ndTxt', label: Dict.auth2ndTxt.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'lastActTime', label: Dict.lastActTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'logoutTime', label: Dict.logoutTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'classRank', label: Dict.classRank.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} }, */
        ]
    },
    uploadTableProps: {
        tableId: 'userInfoUploadTable',
        uniqueKey: Dict.userId.id,
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
            noSorting: true,
            hideBubble: true,
        },
        columns:[
            { id: 'ok', label: '상태', width: 50, show: true, option:{align: 'center', print:(r,i,v)=>v?'OK':<span style={{color:'red'}}>오류</span>} },
            { id: 'userName', label: Dict.userName.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'userId', label: Dict.userId.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'password', label: Dict.password.label, width: 90, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'zipCd', label: Dict.zipCd.label, width: 65, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'addr', label: Dict.addr.label, width: 140, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'telno', label: Dict.telno.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'authClassId', label: Dict.authClassId.label, width: 50, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'dcCd', label: Dict.dcCd.label, width: 60, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'storeId', label: Dict.storeId.label, width: 70, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'comId', label: Dict.comId.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            
       ]
    }
};
